import React from 'react'
import { toMoney } from '@mobi/utils/money'
import { Accordion } from '@mobi/component-library/Common/V2/Accordion'
import type { BetSlipItem, MultiInvestment } from '@mobi/betslip/types'
import type { BetSlipBetsState } from '@mobi/betslip/Store/Bets'
import { useAppSelector } from '@mobi/betslip/Store/hooks'
import { PriceChange, getPriceChange } from '@mobi/betslip/helpers/getPriceChange'
import { MultiReturn } from './Components/MultiReturn/MultiReturn'
import { MIN_LEGS_IN_MULTI } from '../../helpers/constants'
import {
  calculateMultiProjectedPay,
  calclulateCombinedMultiInvestment,
  calculateMultiReturn,
  calculateLastSeenMultiReturn,
} from '../../helpers/calculator'
import { MultiFormula } from './Components/MultiFormula/MultiFormula'
import { MultiItem } from './Components/MultiItem/MultiItem'
import {
  getBetsInMulti,
  hasTooFewMultiLegs,
  hasTooManyMultiLegs,
  isValidMulti,
  isValidMultiInvestmentForLegs,
} from '../../helpers/state'
import { Investment } from '../Common/Investment'

interface ItemListStateProps {
  items: BetSlipItem[]
  disabled: boolean
  multiBetError: BetSlipBetsState['multiBetError'] | null
  multiInvestment: MultiInvestment
}

const handleExpandablePanelClick = () => {
  // ToggleBetslipExpandable('Multi')
}

// TODO: TEMP remove when working on multi
export const shouldRenderMulti = false

export const Multi: React.FC<{ items: BetSlipItem[] }> = ({ items }) => {
  const workflowStatus = useAppSelector(state => state.betslip.workflow.currentStatus)
  const isBusy = useAppSelector(state => state.betslip.workflow.isBusy)

  const hasProposed = workflowStatus === 'proposed'
  const isEditable = workflowStatus === 'ready'

  // TODO: Use redux
  const receipt = {}
  const { disabled, multiBetError, multiInvestment } = {
    disabled: hasProposed || isBusy || receipt != null,
    multiBetError: null,
    multiInvestment: {} as BetSlipBetsState['multiInvestment'],
  } as ItemListStateProps

  const anyBetsPlaced = items.some(x => !!x.receipt) || !!receipt
  const selectedMultiItems = getBetsInMulti(items)

  const isMultiValid = isValidMulti(multiInvestment, multiBetError, selectedMultiItems)
  const isMultiInvestmentValid = isValidMultiInvestmentForLegs(
    multiInvestment,
    selectedMultiItems.length
  )

  if (hasProposed && !isMultiValid && !multiBetError) return null

  const hasEnoughSelections = selectedMultiItems.length >= MIN_LEGS_IN_MULTI
  const hasTooManyLegs = hasTooManyMultiLegs(selectedMultiItems)
  const showBetTypeToggle = !anyBetsPlaced && !hasProposed

  const multiTotalCost = calclulateCombinedMultiInvestment(selectedMultiItems, multiInvestment)
  const multiReturn = calculateMultiReturn(items, { shouldRound: true })
  const multiReturnLastSeen = calculateLastSeenMultiReturn(items, { shouldRound: true })
  const multiReturnPriceChange: PriceChange = multiReturnLastSeen
    ? getPriceChange(multiReturnLastSeen, multiReturn)
    : 'NoChange'

  const isValidNumberOfLegs = !hasTooFewMultiLegs(selectedMultiItems) && !hasTooManyLegs

  const handleInvestmentClick = () => {
    // SetQuickEditInvestment(multiInvestment.value)
    // ToggleBonusCash(multiInvestment.isBonusCash ?? true)
    // SetBonusBet(
    //   multiInvestment.bonusBetId
    //     ? { campaignId: multiInvestment.bonusBetId, value: multiInvestment.value }
    //     : null
    // )
    // SetQuickEditValue(multiInvestment.value)
    // dispatch(
    //   openModal({
    //     id: QUICK_EDIT_MODAL,
    //     modalComponent: QuickEdit,
    //     modalComponentProps: {
    //       title: 'Multi Bet',
    //       subTitle: `${selectedMultiItems.count()} Legs`,
    //     },
    //     color: 'dark',
    //   })
    // )
  }

  if (!shouldRenderMulti) {
    return null
  }

  return (
    <Accordion
      title='Multi (1)'
      onToggle={handleExpandablePanelClick}
      shouldStartExpanded={true}
      shouldUseDefaultTheme={false}
    >
      <div style={{ color: 'red', fontSize: '1.4rem' }}>
        <pre>TODO: WiP Multi TBD</pre>
      </div>

      <div>
        {!hasEnoughSelections && <div>Error: {`${MIN_LEGS_IN_MULTI} legs minimum for Multi`}</div>}

        {!multiBetError?.errorMessage && hasTooManyLegs && (
          <>
            <div>Error: Exceeded number of allowed legs for Multi bet. Please amend your bet.</div>
          </>
        )}

        {multiBetError?.errorMessage && (
          <div>
            Error:{' '}
            {multiBetError.errorMessage.indexOf('Multibet') > -1 &&
            multiBetError.errorMessage.indexOf('must contain no more than') > -1
              ? 'Exceeded number of allowed legs for Multi bet. Please amend your bet.'
              : multiBetError.errorMessage}
          </div>
        )}

        {multiInvestment.f1 > 0 && !isMultiInvestmentValid && (
          <div>
            Warning: Invalid formula investment, &quot;Singles only&quot; is not a valid bet type.
          </div>
        )}

        {receipt ? null : (
          <>
            <div>
              {items.map(item => (
                <MultiItem
                  key={item.id || ''}
                  item={item}
                  disabled={disabled}
                  showBetTypeToggle={showBetTypeToggle}
                />
              ))}
            </div>

            <div onClick={!disabled && isValidNumberOfLegs ? handleInvestmentClick : undefined}>
              <Investment
                isActive={false}
                itemId='multi'
                investmentType='Win'
                label='Spend'
                isEditable={isEditable}
                value={multiInvestment.value}
                // priceChange='NoChange'
                // isEditable={!disabled && isValidNumberOfLegs}
                // isBonusBet={multiInvestment.isBonusBet}
              />
            </div>

            <div>
              <div>
                Multi Rtn
                <MultiReturn price={multiReturn} priceChange={multiReturnPriceChange} />
              </div>

              <div>
                <div>No. Legs {selectedMultiItems.length}</div>
              </div>

              <div>
                Proj. Pay {toMoney(calculateMultiProjectedPay(selectedMultiItems, multiInvestment))}
              </div>
            </div>

            <MultiFormula />

            {multiTotalCost > 0 && <div>Total Multi Cost ${multiTotalCost.toFixed(2)}</div>}
          </>
        )}
      </div>
    </Accordion>
  )
}
